import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchLatestNotes = createAsyncThunk(
  'notifications/fetchLatestNotes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/users/notifications/');
      console.log('Notes response:', response.data);

      if (!response.data || typeof response.data[Symbol.iterator] !== 'function') {
        console.error('Invalid response format:', response.data);
        return rejectWithValue('Invalid response format from server');
      }

      return response.data;
    } catch (error) {
      console.error('Error details:', {
        response: error.response,
        status: error.response?.status,
        data: error.response?.data,
        headers: error.response?.headers
      });
      
      return rejectWithValue(
        error.response?.data?.detail || 
        error.message || 
        'Failed to fetch notifications'
      );
    }
  }
);

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    latestNotes: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestNotes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestNotes.fulfilled, (state, action) => {
        state.loading = false;
        state.latestNotes = action.payload;
        state.error = null;
      })
      .addCase(fetchLatestNotes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.error('Failed to fetch notes:', action.payload); // Debug log
      });
  }
});

export default notificationsSlice.reducer; 